import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { LegalPage } from '../components/legal-page';

const SECTIONS = [
  {
    heading: '1. Introduction',
    body: [
      'This Privacy Policy explains how Kast collects, uses, shares, and protects information when you use our website, applications, and related services (the "Service").',
    ],
  },
  {
    heading: '2. Information We Collect',
    body: [
      'We collect information in the following ways:',
      [
        'Account information you provide, such as your name, email address, and password.',
        'Profile information, including viewer profiles and preferences such as your watchlist and watch history.',
        'Payment information when you subscribe to a paid plan, processed by our payment providers.',
        'Usage data, such as what you watch, how long you watch, device type, and app interactions.',
        'Technical data, including IP address, browser type, and device identifiers.',
      ],
    ],
  },
  {
    heading: '3. How We Use Your Information',
    body: [
      'We use the information we collect to:',
      [
        'Provide, operate, and improve the Service, including personalised recommendations.',
        'Process subscriptions, payments, and content creator payouts.',
        'Communicate with you about your account, updates, and support requests.',
        'Maintain the security of the Service and prevent fraud or abuse.',
        'Understand how the Service is used so we can improve it.',
      ],
    ],
  },
  {
    heading: '4. Cookies & Similar Technologies',
    body: [
      'Kast uses cookies and similar technologies to keep you signed in, remember your preferences, and understand how the Service is used. You can control cookies through your browser settings, though some features of the Service may not work properly without them.',
    ],
  },
  {
    heading: '5. How We Share Information',
    body: [
      'We do not sell your personal information. We may share information with:',
      [
        'Service providers who help us operate Kast, such as payment processors and cloud hosting providers.',
        'Content creators, in aggregated or anonymised form, to help them understand performance of their content.',
        'Authorities, where required by law or to protect the rights, safety, and property of Kast and our users.',
      ],
    ],
  },
  {
    heading: '6. Data Retention',
    body: [
      'We retain your information for as long as your account is active or as needed to provide the Service, comply with legal obligations, resolve disputes, and enforce our agreements.',
    ],
  },
  {
    heading: '7. Your Rights & Choices',
    body: [
      'Depending on where you live, you may have rights to access, correct, delete, or export your personal information. You can update most account and profile information directly in your account settings, or contact us for help with other requests.',
    ],
  },
  {
    heading: "8. Children's Privacy",
    body: [
      'Kast supports Kids profiles that offer a restricted viewing experience within an adult\'s account. The Service is not directed at children for the purpose of independently creating their own account, and we do not knowingly collect personal information directly from children outside of a parent or guardian\'s account.',
    ],
  },
  {
    heading: '9. Security',
    body: [
      'We use reasonable technical and organisational measures designed to protect your information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.',
    ],
  },
  {
    heading: '10. Changes to This Policy',
    body: [
      'We may update this Privacy Policy from time to time. If we make material changes, we will notify you through the Service or by other reasonable means before the changes take effect.',
    ],
  },
  {
    heading: '11. Contact Us',
    body: [
      'If you have questions about this Privacy Policy or how your information is handled, please reach out to us through the Help Centre.',
    ],
  },
];

export default function PrivacyPolicyPage() {
  usePageTitle('Privacy Policy · Kast', 'Learn how Kast collects, uses, and protects your information.');

  return (
    <LegalPage
      title="Privacy Policy"
      lead="Your privacy matters to us. This policy explains what information we collect, how we use it, and the choices you have."
      updated="October 20, 2026"
      sections={SECTIONS}
    />
  );
}
